import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IoPlayOutline } from 'react-icons/io5'
import { Button } from 'src/Common/ui/button'
import Input from 'src/Common/ui/input'
import SelectInput from 'src/Common/ui/selectInput'
import * as PropTypes from 'prop-types'

const ExpectedMonetaryValue = ({ register, formData, setformData, onValueChange, errors, control, type = 'RISK' }) => {
    const { t } = useTranslation()

    // Function to check if all fields are filled
    const isCalculateDisabled = () => {
        if (!formData?.noOfRisksData?.length) return true

        return formData.noOfRisksData.some(
            (mapData) =>
                !mapData.riskName?.trim() || // Ensure riskName is not empty
                mapData.probability === '' || mapData.probability === null || mapData.probability === undefined ||
                mapData.cost === '' || mapData.cost === null || mapData.cost === undefined
        )
    }

    const handleCalculate = () => {
        const totalEMV = formData?.noOfRisksData
            ?.map((mapData) => Number(mapData?.probability) * Number(mapData?.cost))
            ?.reduce((previousScore, currentScore) => previousScore + currentScore, 0)

        setformData({
            ...formData,
            totalEMV
        })
    }

    return (
        <div>
            <Box display="grid" sx={{ paddingBottom: 4 }} gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} gridColumn="span 3">
                    <div className='relative flex flex-col justify-between'>
                        <SelectInput
                            label={t(`No of ${type === 'RISK' ? 'Risks' : 'Issue'}`)}
                            control={control}
                            errors={errors}
                            name="noOfRisks"
                            placeholder={`Select ${type === 'RISK' ? 'Risks' : 'Issue'}`}
                            onValueChange={onValueChange}
                            value={formData?.noOfRisks}
                            defaultValue={1}
                            required
                            rules={{ required: 'This field is Required' }}
                            options={[{ label: '1', value: 1 }, { label: '2', value: 2 }, { label: '3', value: 3 }, { label: '4', value: 4 }]}
                        />
                    </div>
                </Box>
            </Box>

            {formData?.noOfRisksData?.map((mapData, index) => (
                <Box key={index} display="grid" sx={{ paddingBottom: 4 }} gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} gridColumn="span 3">
                        <div className='relative flex flex-col justify-between'>
                            <Input
                                errors={errors}
                                required
                                rules={{ required: `${type === 'RISK' ? 'Risk' : 'Issue'} ${index + 1} Name is required` }}
                                control={control}
                                name={`riskName_${index}`}
                                label={t(`${type === 'RISK' ? 'Risk' : 'Issue'} ${index + 1} Name`)}
                                register={register}
                                placeholder={t(`Enter ${type === 'RISK' ? 'Risk' : 'Issue'} ${index + 1} Name`)}
                                type="text"
                                value={mapData?.riskName}
                                onValueChange={(el, name) => onValueChange(el?.target.value, 'riskName', index)}
                            />
                        </div>
                    </Box>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} gridColumn="span 2">
                        <div className='relative flex flex-col justify-between'>
                            <Input
                                errors={errors}
                                control={control}
                                name={`probability_${index}`}
                                label={t('Probability')}
                                register={register}
                                placeholder={t('Enter Probability')}
                                type="number"
                                value={mapData?.probability}
                                onValueChange={(el, name) => onValueChange(el?.target.value, 'probability', index)}
                                rules={{ min: { value: 0, message: t('Probability must be at least 0') }, max: { value: 100, message: t('Probability must not exceed 100') } }}
                            />
                        </div>
                    </Box>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} gridColumn="span 2">
                        <div className='relative flex flex-col justify-between'>
                            <Input
                                errors={errors}
                                control={control}
                                name={`cost_${index}`}
                                label={t('Cost')}
                                register={register}
                                placeholder={t('Enter Cost')}
                                type="number"
                                value={mapData?.cost}
                                onValueChange={(el, name) => onValueChange(el?.target.value, 'cost', index)}
                                rules={{ min: { value: 0, message: t('Cost must be at least 0') }, max: { value: 999999999999, message: t('Cost must not exceed 999999999999') } }}
                            />
                        </div>
                    </Box>
                </Box>
            ))}

            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                <Box sx={{ height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '20px' }} gridColumn={'span 7'}>
                    <Button
                        component='label'
                        size='small'
                        onClick={handleCalculate}
                        disabled={isCalculateDisabled()} // Disable based on conditions
                    >
                        <span className="flex text-card items-center" style={{ fontWeight: 'bold' }}>
                            <IoPlayOutline color='hsl(var(--card))' className="mr-2" size={15} /> Calculate
                        </span>
                    </Button>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <p className='text-primary font-bold pb-2'>Total Expected Monetary Value (EMV): </p>
                        <p className='text-muted font-bold break-words'>₹ {formData?.totalEMV || 0}</p>
                    </div>
                </Box>
            </Box>
        </div>
    )
}

ExpectedMonetaryValue.propTypes = {
    register: PropTypes.any,
    formData: PropTypes.any,
    onValueChange: PropTypes.any,
    errors: PropTypes.any,
    control: PropTypes.any
}

export default ExpectedMonetaryValue
